module.controller(
		'siteDetailCtrl',
		[ '$scope', '$rootScope', '$state', 'clientService', 'alertService', 
		  function($scope, $rootScope, $state, clientService, alertService) {

			$scope.validation = {
					observations : {
						maxlength : 500
					}				
			};

			$scope.operationType = $state.current.data.type;
			$scope.idClient = $state.params.idClient;
			$scope.idSite = $state.params.idSite;
			$scope.site = {
					country: {},
					city: {},
					zone: {},
					requireConfirmation : false
			};
			$scope.loading = false;
			$scope.contact = {};

			/**
			 * 
			 */
			 $scope.load = function(idClient, idSite) {
				$scope.loading = true;

				clientService.getClientSite(idClient, idSite).then(function(response) {
					$scope.loading = false;

					var responseData = response.getData();
					$scope.site = {
							country: {
								selected: [{
									id: responseData.country.id,
									name: responseData.country.name,
									value: responseData.country.value
								}]
							},
							city: {
								selected: [{
									id: responseData.city.id,
									name: responseData.city.name,
									value: responseData.city.value
								}]
							},
							zone: {
								selected: [{
									id: responseData.zone.id,
									name: responseData.zone.name,
									value: responseData.zone.value
								}]
							},
							name: responseData.name,
							address: responseData.address,
							observation: responseData.observation,
							requireConfirmation : responseData.requireConfirmation,
							contact: responseData.contact
					};

					if(responseData.contact){
						$scope.contact = {
								selected: [{
									id: responseData.contact.id,
									name: responseData.contact.name,
									value: responseData.contact.value
								}]
						};	
					}
					else{
						$scope.contact = {};
					}


				}, function(response) {
					$scope.loading = false;
				});
			 };

			 /**
			  *
			  */
			 $scope.sendAction = function() {
				 if ($scope.operationType == 'create') {
					 $scope.create();
				 } else {
					 $scope.update();
				 }
			 };

			 /**
			  *
			  */
			 $scope.create = function() {
				 alertService.showSwtQuestion('Crear Punto de Cliente', function() {
					 $scope.loading = true;

					 var createModel = {
							 name: $scope.site.name,
							 address: $scope.site.address,
							 idCountry: $scope.site.country.selected[0].id,
							 idCity: $scope.site.city.selected[0].id,
							 idZone: $scope.site.zone.selected[0].id,
							 observation: $scope.site.observation,
							 requireConfirmation: $scope.site.requireConfirmation 
					 };

					 clientService.createClientSite($scope.idClient, createModel).then(function(response) {
						 $scope.loading = false;
						 alertService.showSuccess('Punto creado satisfactoriamente');
						 $state.go('home.clientSites', {idClient : $scope.idClient});
					 }, function(response) {
						 $scope.loading = false;
					 });
				 });
			 };

			 /**
			  *
			  */
			 $scope.update = function() {
				 alertService.showSwtQuestion('Actualizar Punto de Cliente', function() {
					 $scope.loading = true;

					 var updateModel = {
							 name: $scope.site.name,
							 address: $scope.site.address,
							 idCountry: $scope.site.country.selected[0].id,
							 idCity: $scope.site.city.selected[0].id,
							 idZone: $scope.site.zone.selected[0].id,
							 observation: $scope.site.observation,
							 requireConfirmation: $scope.site.requireConfirmation 
					 };

					 clientService.updatedClientSite($scope.idClient, $scope.idSite, updateModel).then(function(response) {
						 $scope.loading = false;
						 alertService.showSuccess('Punto actualizado satisfactoriamente');
						 $state.go('home.clientSites', {idClient : $scope.idClient});
					 }, function(response) {
						 $scope.loading = false;
					 });
				 });
			 };

			 /**
			  * 
			  */
			 $scope.onCountryChange = function(country){
				 $scope.site.city = {};
				 $scope.site.zone = {};
			 };

			 /**
			  * 
			  */
			 $scope.onCityChange = function(city){
				 $scope.site.zone = {};
			 };

			 $scope.asignContactToSite = function(idContact){
				 alertService.showSwtQuestion('Asignar contacto al punto', function() {
					 $scope.loading = true;

					 var contactModel = {
							 id: idContact
					 };

					 clientService.asignContactToSite($scope.idClient, $scope.idSite, contactModel).then(function(response) {
						 $scope.loading = false;
						 alertService.showSuccess('Contacto asignado a punto satisfactoriamente');
						 $state.go('home.clientSites', {idClient : $scope.idClient});
					 }, function(response) {
						 $scope.loading = false;
					 });
				 });
			 };

			 if ($scope.operationType == 'update') {
				 $scope.load($scope.idClient, $scope.idSite);
			 }

		} ]);


